module.exports = __webpack_public_path__ + "img/minus-symbol.fdfcb7ef.png";